import React, { useState } from "react";

export default function OrderPanel({
  option,
  copyTradeSymbol,
  chainGeneration,
  tradeDisabled = false,
  tradeDisabledReason = ""
}) {
  const [loading, setLoading] = useState(false);

  const placeOrder = async (side) => {
    if (!option) {
      alert("Select CE/PE first");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch("/api/order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tradingsymbol: option.tradingsymbol,
          exchange: option.exchange,
          expiry: option.expiry,
          instrument_token: option.instrument_token,
          side,
          qty: option.lot_size,
          strike: option.strike,
          type: option.type,
          copy_trade_symbol: copyTradeSymbol,
          chain_generation: chainGeneration,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.detail || data.error || "Order failed");
        return;
      }

      alert(`${side} order placed ✅`);
    } catch (err) {
      console.error(err);
      alert("Network error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        border: "1px solid #2a2a2a",
        borderRadius: "12px",
        background: "#111",
        color: "#eaeaea",
        minWidth: "240px",
        minHeight: "136px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* 🔥 FIXED BUTTONS (sticky like trading apps) */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          padding: "10px 12px",
          borderBottom: "1px solid #1f2937",
          background: "#111",
          position: "sticky",
          top: 0,
          zIndex: 2,
        }}
      >
        <button
          disabled={loading || !option || tradeDisabled}
          onClick={() => placeOrder("BUY")}
          style={{
            flex: 1,
            background: "#16c784",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            fontWeight: "bold",
            cursor: tradeDisabled ? "not-allowed" : "pointer",
            opacity: loading || tradeDisabled ? 0.6 : 1,
          }}
        >
          {loading ? "Placing..." : "BUY"}
        </button>

        <button
          disabled={true}
          onClick={() => placeOrder("SELL")}
          style={{
            flex: 1,
            background: "#ea3943",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            fontWeight: "bold",
            cursor: "not-allowed",
            opacity: 0.6,
          }}
        >
          {loading ? "Placing..." : "SELL"}
        </button>
      </div>

      {/* 🔥 SCROLLABLE CONTENT */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          padding: "10px 12px 12px",
        }}
      >
        {tradeDisabled && tradeDisabledReason && (
          <div
            style={{
              marginBottom: "8px",
              padding: "8px",
              border: "1px solid #92400e",
              borderRadius: "7px",
              background: "#1f1305",
              color: "#fbbf24",
              fontSize: "11px"
            }}
          >
            {tradeDisabledReason}
          </div>
        )}
        {option ? (
          <div
            style={{
              background: "#1a1a1a",
              padding: "10px 12px",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
          >
            {/* 🔥 SYMBOL + TYPE */}
            <div
              style={{
                fontSize: "15px",
                fontWeight: "700",
                color: "#f9fafb",
                letterSpacing: "0.4px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "80%"
                }}
                title={option.tradingsymbol}
              >
                {option.tradingsymbol}
              </span>

              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  padding: "3px 8px",
                  borderRadius: "6px",
                  background:
                    option.type === "CE"
                      ? "rgba(34,197,94,0.15)"
                      : "rgba(239,68,68,0.15)",
                  color: option.type === "CE" ? "#22c55e" : "#ef4444",
                }}
              >
                {option.type}
              </span>
            </div>

            {/* 🔥 INFO ROWS */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "2px 0"
            }}>

              <div style={{ display: "flex", gap: 8 }}>
                <span style={{ ...labelStyle, width: 50 }}>Strike</span>
                <span style={valueStyle}>{option.strike}</span>
              </div>

              <div style={{ display: "flex", gap: 8 }}>
                <span style={{ ...labelStyle, width: 40 }}>Qty</span>
                <span style={valueStyle}>{option.lot_size}</span>
              </div>

              <div style={{ display: "flex", gap: 8 }}>
                <span style={{ ...labelStyle, width: 40 }}>Price</span>
                <span style={valueStyle}>{option.price}</span>
              </div>


            </div>
          </div>
        ) : (
          <div
            style={{
              opacity: 0.6,
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            Select CE / PE to trade
          </div>
        )}
      </div>
    </div>
  );
}

/* 🔥 Reusable styles (clean code) */
const labelStyle = {
  color: "#9ca3af",
};

const valueStyle = {
  fontWeight: "500",
};
